export const CHAT_ATTACHMENT_LIST_HEADER = [
  { label: 'chatAttachments.name', property: 'NAME' },
  { label: 'chatAttachments.title', property: 'TITLE' },
  { label: 'chatAttachments.description' },
  { label: 'chatAttachments.size', property: 'SIZE' },
];
